// Keep this legacy module path while removing the old cache-first behavior.
export default function unregisterServiceWorker() {
  window.addEventListener('load', () => {
    const unregisterWorkers = 'serviceWorker' in navigator
      ? navigator.serviceWorker.getRegistrations().then(registrations => {
          return Promise.all(registrations.map(registration => registration.unregister()));
        })
      : Promise.resolve();

    const clearStoredCaches = 'caches' in window
      ? caches.keys().then(cacheNames => {
          return Promise.all(cacheNames.map(cacheName => caches.delete(cacheName)));
        })
      : Promise.resolve();

    Promise.all([unregisterWorkers, clearStoredCaches]).catch(() => {
      // Cache cleanup is best-effort and must never prevent the app from loading.
    });
  });
}
